<app-confirmation-dialog [props]="confirmationDialogProps" id="doc-ind-modal-dialog">
  <div class="indicators-modal-content" id="doc-ind-modal-content">
    <div id="doc-ind-modal-header-info">
      <span id="doc-ind-modal-span-name"><b i18n="@@name">Nombre:</b> {{name}}</span>
      @if (personType === 'PERSON') {
        <span id="doc-ind-modal-span-person-info"><b i18n="@@id">Identificación</b>: {{document | cpfMask }}</span>
      }
      @if (personType === 'COMPANY') {
        <span id="doc-ind-modal-span-company-info"><b i18n="@@id">Identificación</b>: {{document | cnpjMask }}</span>
      }
    </div>
    <table class="table" id="doc-ind-modal-tbl-indicators">
      <thead id="doc-ind-modal-thead">
        @for (headerTitle of table.titles; track headerTitle; let i = $index) {
          <tr id="doc-ind-modal-thead-tr-{{i}}">
            <th class="header-table" id="doc-ind-modal-th-attr-{{i}}">{{headerTitle.attribute}}</th>
            <th class="header-table text-center" id="doc-ind-modal-th-qty-{{i}}">{{headerTitle.quantity}}</th>
            <th class="header-table text-center" id="doc-ind-modal-th-val-{{i}}">{{headerTitle.totalValue}}</th>
            <th class="header-table text-center" id="doc-ind-modal-th-date-{{i}}">{{headerTitle.updateDate}}</th>
          </tr>
        }
      </thead>
      <tbody id="doc-ind-modal-tbody">
        @for (restrictive of restrictives; track restrictive; let i = $index) {
          <tr id="doc-ind-modal-tbl-row-{{i}}">
            <td id="doc-ind-modal-td-name-{{i}}">
              {{restrictive.name}}
            </td>
            <td class="quantity-column" id="doc-ind-modal-td-qty-{{i}}">
              {{ restrictive.quantity | thousandsMask }}
            </td>
            <td class="total-value-column" id="doc-ind-modal-td-val-{{i}}">
              {{ restrictive.totalValue | number:'1.2-2' }}
            </td>
            <td class="date-column" id="doc-ind-modal-td-date-{{i}}">
              {{restrictive.date}}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</app-confirmation-dialog>
